/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TenantSettingsControllerService {
    /**
     * @param tenantId
     * @param requestBody
     * @returns any Update notification preferences for a tenant
     * @throws ApiError
     */
    public static tenantSettingsControllerUpdateNotificationPreferences(
        tenantId: string,
        requestBody?: {
            email: boolean;
            pushNotification: boolean;
        },
    ): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/tenants/{tenantId}/notification-preferences',
            path: {
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param tenantId
     * @returns any Get notification preferences for a tenant
     * @throws ApiError
     */
    public static tenantSettingsControllerGetNotificationPreferences(
        tenantId: string,
    ): CancelablePromise<{
        email?: boolean;
        pushNotification?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tenants/{tenantId}/notification-preferences',
            path: {
                'tenantId': tenantId,
            },
        });
    }
}
